import { Link } from 'react-router-dom';

import { Button } from '@/componentes/ui/button';

/**
 * O atalho para a etapa que preenche o dado que falta. Aparece na capa e nas
 * recomendações, e é `data-nao-imprimir`: botão no PDF é tinta morta.
 */
export function AcoesDoQueFalta({ falta }: { falta: 'ticket' | 'volume' }) {
  return (
    <div data-nao-imprimir="" className="flex flex-wrap gap-2">
      {falta === 'volume' ? (
        <>
          <Button asChild size="sm">
            <Link to="/sazonalidade">Preencher a sazonalidade</Link>
          </Button>
          <Button asChild variant="outline" size="sm">
            <Link to="/indicadores">Informar projetos por mês</Link>
          </Button>
        </>
      ) : (
        <Button asChild size="sm">
          <Link to="/projeto">Preencher os dados do projeto</Link>
        </Button>
      )}
    </div>
  );
}
